import { FareFamilyApiResponse, Plan } from '@/src/components/desktop/srp/fareFamily/types'
import { FlightCard } from '@/src/types/flight'

const debugMode = false

export const fareFamilyRulePriceModifierOnwardLeg = ({
    fareFamilyData,
    card,
    returnCards
}: {
    fareFamilyData: FareFamilyApiResponse
    card: FlightCard
    returnCards: FlightCard[]
}) => {
    if (debugMode) {
        console.log('fareFamilyRulePriceModifierOnwardLeg debug mode is enabled')
        console.log('onwardCard', card)
        console.log('fareFamilyData', fareFamilyData)
    }
    //copy fareFamilyData to mutable object
    const fareFamilyDataCopy: FareFamilyApiResponse = JSON.parse(JSON.stringify(fareFamilyData))
    const fareFamilyFareRules = fareFamilyDataCopy?.responseBody?.data?.solutions[0]?.fareFamilyFareRules

    const totalRTPrice = card?.priceBreakup?.multiAirlinePrice

    //add appliedCheapestReturnCardPrice to each fareFamilyFareRule
    fareFamilyFareRules.forEach(rule => {
        if (rule.ctBrandName === 'Regular') {
            rule.unModifiedTotalPrice = rule.totalPrice
            rule.totalPrice = totalRTPrice || 0

            if (debugMode) {
                console.log(
                    `${rule.ctBrandName} -> price: ${totalRTPrice} | isSpecialRT: ${!!card.priceBreakup.isMultiAirlinePriceSpecialRT} | returnCardId:${card.usedRegularFareReturnCardId} | onwardCardId: ${card.id}`
                )
            }
        } else {
            // Find the cheapest combination of rule.totalPrice + returnCard.priceBreakup.pr
            let usedReturnCardId = 'initialCheapest'
            if (returnCards.length > 0) {
                const cheapestPrice = returnCards.reduce((min, returnCard) => {
                    const sum = (rule.totalPrice || 0) + (returnCard?.priceBreakup?.pr || 0)
                    if (debugMode) {
                        if (sum < min) {
                            usedReturnCardId = returnCard.id
                        }
                    }
                    return Math.min(min, sum)
                }, Infinity)
                rule.unModifiedTotalPrice = rule.totalPrice
                rule.totalPrice = cheapestPrice

                if (debugMode) {
                    console.log(
                        `${rule.ctBrandName} -> price: ${cheapestPrice} | isSpecialRT: false | returnCardId:${usedReturnCardId} | onwardCardId: ${card.id}`
                    )
                }
            }
            // If returnCards is empty, rule.totalPrice remains unchanged
        }
        rule.showTotalRTPriceMessage = true
    })

    //sort fareFamilyFareRules by totalPrice
    fareFamilyFareRules.sort((a, b) => (a.totalPrice || 0) - (b.totalPrice || 0))
    //modify fareFamilyDataCopy for onward journey
    return fareFamilyDataCopy
}

export const fareFamilyRulePriceModifierReturnLeg = ({
    fareFamilyData,
    card,
    selectedOnwardFareFamilyPlan,
    selectedOnwardCard,
    showTotalRTPrice = true
}: {
    fareFamilyData: FareFamilyApiResponse
    card: FlightCard
    selectedOnwardFareFamilyPlan: Plan
    selectedOnwardCard: FlightCard
    showTotalRTPrice?: boolean
}) => {
    //copy fareFamilyData to mutable object
    const fareFamilyDataCopy: FareFamilyApiResponse = JSON.parse(JSON.stringify(fareFamilyData))
    const fareFamilyFareRules = fareFamilyDataCopy?.responseBody?.data?.solutions[0]?.fareFamilyFareRules

    const onwardFareUnmodifiedPrice =
        selectedOnwardFareFamilyPlan?.unModifiedTotalPrice || selectedOnwardCard?.priceBreakup?.pr || 0

    const selectedOnwardFareMultiAirlinePrice =
        selectedOnwardFareFamilyPlan?.price || selectedOnwardCard?.priceBreakup?.multiAirlinePrice || 0 //this price (onward selected fare price + return regular fare price)

    fareFamilyFareRules.forEach(rule => {
        if (rule.ctBrandName === 'Regular') {
            const returnCardRegularMultiAirlinePrice = card?.priceBreakup?.multiAirlinePrice
            rule.unModifiedTotalPrice = rule.totalPrice
            rule.totalPrice = showTotalRTPrice
                ? (selectedOnwardFareMultiAirlinePrice || 0) + (returnCardRegularMultiAirlinePrice || 0)
                : returnCardRegularMultiAirlinePrice || 0
        } else {
            const currentRulePrice = rule?.totalPrice
            rule.unModifiedTotalPrice = currentRulePrice
            const additionalPrice = onwardFareUnmodifiedPrice + currentRulePrice - selectedOnwardFareMultiAirlinePrice //if want to show additional price from onward fare
            rule.totalPrice = showTotalRTPrice ? onwardFareUnmodifiedPrice + currentRulePrice : additionalPrice // total price
        }
        rule.showTotalRTPriceMessage = showTotalRTPrice
        rule.planPricePrefix = showTotalRTPrice ? undefined : '+'
    })
    //sort fareFamilyFareRules by totalPrice
    fareFamilyFareRules.sort((a, b) => (a.totalPrice || 0) - (b.totalPrice || 0))

    //modify fareFamilyDataCopy for onward journey
    return fareFamilyDataCopy
}
